/** `1234.5` → `"1,234.50"` — grouped thousands, always two decimals. */
function usd(n: number): string {
  return Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Format a dollar amount, e.g. `$4.20` / `-$1.00` / `$39,836.03`. */
export function fmtUsd(n: number): string {
  return `${n < 0 ? '-' : ''}$${usd(n)}`;
}

/** Format a signed dollar amount for a gain/loss chip, e.g. `+$4.00` / `-$39,836.03`. */
export function signedUsd(n: number): string {
  return `${n >= 0 ? '+' : '-'}$${usd(n)}`;
}

/** Price label: cents under a dollar (`95¢`), otherwise dollars (`$1.20`); `—` when unknown (≤0). */
export function fmtPrice(dollars: number): string {
  if (dollars <= 0) return '—';
  return dollars < 1 ? `${Math.round(dollars * 100)}¢` : `$${dollars.toFixed(2)}`;
}

/** Short clock label for an ISO timestamp, e.g. `3:00 PM`; `—` when missing/invalid. Locale pinned to en-US. */
export function fmtTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

/** Date + clock label for an ISO timestamp, e.g. `Dec 31, 1:02 PM`; `—` when missing/invalid. Locale pinned to en-US. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const day = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${day}, ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`;
}
